<script>
	import {Router, Route, Link} from "svelte-routing";
	import {network, store} from './stores.js';
	import {list, page} from './config.js';
	import storage from "./storage";

	import Auth from "./routes/Auth.svelte";
	import Dashboard from './routes/Dashboard.svelte';
	import List from './routes/List.svelte';
	import Order from "./routes/Order.svelte";
	import Calc from './routes/Calc.svelte';
	import Checkout from "./routes/Checkout.svelte";
	import Loading from "./routes/Loading.svelte";
	import AccessDenied from "./routes/AccessDenied.svelte";

	const user = store('credential', 'getAuth');

	export let url = "";

	let css = null;
	if ((location.query && location.query.css)) {
		css = decodeURIComponent(location.query.css);
		storage.setItem('external_css', css);
	} else if (storage.getItem('external_css')) {
		css = storage.getItem('external_css');
	}

	const window_active = async () => {
		const LAST_CALL_KEY = 'window_active_last_time';
		const now = Date.now();
		const cooldown = 3 * 60 * 1000; // в миллисекундах
		const lastCall = parseInt(localStorage.getItem(LAST_CALL_KEY) || '0');

		if (now - lastCall >= cooldown) {
			try {
				await network.send_window_active();
				localStorage.setItem(LAST_CALL_KEY, now.toString());
			} catch (err) {
				console.error('Error window active:', err);
			}
		}

		window.top.postMessage('focus', '*');
	}
</script>

<svelte:window on:click={window_active} />

<svelte:head>
	{#if css}
		<link rel="stylesheet" href="{css}">
	{/if}
</svelte:head>

<!-- App Capsule -->
<Router url="{url}">
	<Route path="/" component={Auth} />

	{#if $user.id > 0}
		<Route path="/dashboard" component={Dashboard} />

		<Route path="/list/:vid" let:params >
			<List vid="{params.vid}" />
		</Route>
		<Route path="/list/:vid/:id" let:params>
			<Order vid="{params.vid}" id="{params.id}" />
		</Route>

		{#each list as item}
		    {#if $user.calcs && $user.calcs.split(',').find((uc) => uc === item.calc) }
			    <Route path="/calc/{encodeURI(item.link)}" component={Calc} calc={item} inside={item.component} components={item.components || []} options={item.options || {}} />
            {/if}
		{/each}

		{#each page as item}
			<Route path="/{encodeURI(item.link)}" component={item.component} components={item.components || []} options={item.options || {}} />
		{/each}
	{/if}

	<Route path="/checkout" component={Checkout} />
	<Route path="/loading" component={Loading} />
	<Route path="/*" component={AccessDenied} />
</Router>
<!-- * App Capsule -->
